import { useEffect, useRef, useState } from "react";
import { FileText, CheckCircle2, Loader2, Upload } from "lucide-react";
import { api } from "@/lib/api";

export function useTranscriptInfo(id) {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    setInfo(null);
    if (id) api.get(`/files/${id}/info`).then((r) => setInfo(r.data)).catch(() => setInfo(null));
  }, [id]);
  return info;
}

export function TranscriptBadge({ info }) {
  if (!info) return null;
  return (
    <div className="rounded-lg border border-emerald-500/40 bg-emerald-500/10 p-3" data-testid="transcript-confirmation">
      <p className="text-sm font-medium text-emerald-300 flex items-center gap-2"><CheckCircle2 className="h-4 w-4 shrink-0" /><span className="truncate">Agent nutzt: {info.name} · {info.words} Wörter</span></p>
      {info.excerpt && <p className="text-xs text-slate-400 mt-1.5 line-clamp-3 italic" data-testid="transcript-excerpt">„{info.excerpt}…“</p>}
    </div>
  );
}

export function TranscriptUploadButton({ onFile, busy, busyLabel = "Wird hochgeladen…", label = "Transkript (.txt) hochladen", testId = "transcript-upload-button" }) {
  const ref = useRef(null);
  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy}
        className="w-full h-11 rounded-lg border border-dashed border-purple-400/60 bg-purple-500/10 hover:bg-purple-500/20 text-purple-100 text-sm font-medium flex items-center justify-center gap-2 transition-colors disabled:opacity-60" data-testid={testId}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}{busy ? busyLabel : label}
        <FileText className="h-4 w-4 opacity-60" />
      </button>
      <input ref={ref} type="file" accept=".txt,text/plain" className="hidden" onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) onFile(f); }} data-testid={`${testId}-input`} />
    </>
  );
}
